import {
  ClockIcon,
  DotsCircleHorizontalIcon,
  ExclamationIcon,
  QuestionMarkCircleIcon,
  XCircleIcon,
} from "@heroicons/react/solid";
import { useTranslation } from "react-i18next";
import { SubmissionStatus } from "../../api/models/CandidateSubmissionModel";

type CandidateSubmissionStatusProps = {
  status: SubmissionStatus;
};
export default function CandidateSubmissionStatus({
  status,
}: CandidateSubmissionStatusProps) {
  const LocalBasePath = "page.liaison.dashboard.candidates";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });

  const statusIcon = {
    [SubmissionStatus.waiting_audio]: (
      <ClockIcon className="w-5 h-5 text-[#EEC356]" />
    ),
    [SubmissionStatus.pending]: (
      <QuestionMarkCircleIcon className="w-5 h-5 text-[#818CF8]" />
    ),
    [SubmissionStatus.re_submitted]: (
      <ExclamationIcon className="w-5 h-5 text-[#F6A01E]" />
    ),
    [SubmissionStatus.approved]: (
      <DotsCircleHorizontalIcon className="w-5 h-5 text-brandblue-400" />
    ),
    [SubmissionStatus.rejected]: (
      <XCircleIcon className="w-5 h-5 text-red-400" />
    ),
  };

  return (
    <div className="text-gray-900 flex gap-2">
      <div>{statusIcon[status]}</div>
      <div>{t(status)}</div>
    </div>
  );
}
